<app-page-header>
  <span class="page-title"><h3>Staff Room</h3></span>
</app-page-header>
<div class="row">
  @if (!viewSecondPanel) {
  <div class="col-md-3" [ngClass]="{ 'hide-listwrapper': viewStaffRoomList }">
    <div
      class="col se-p second-level-menu is-notification right-box-shadow scroll-bar"
    >
      @if (showSearchSec) {
      <div class="menu-options level is-marginless display-flex">
        <div class="level-left">
          <div class="level-item">
            <div class="select is-small">
              <select [(ngModel)]="sortBy" (change)="getRooms(0)">
                <option value="title">Sort A to Z</option>
                <option value="time">Sort by Recent</option>
              </select>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a class="button is-small" (click)="showSearchBox('open')">
              <i class="fa fa-search"></i>
            </a>
          </div>
        </div>
      </div>
      } @if (!showSearchSec) {
      <div class="menu-options level is-marginless searchBox-pad display-flex">
        <div class="level-left">
          <div class="level-item input-search-box">
            <div class="field">
              <p class="control has-icons-left has-icons-right">
                <input
                  type="text"
                  class="input"
                  inputFocus
                  [(ngModel)]="searchRooms"
                  (keyup)="searchInList.next($event)"
                  placeholder="Search here..."
                />
                <a class="icon is-small is-left" title="search">
                  <i class="fa fa-search"></i>
                </a>
                <span class="input-bar"></span>
              </p>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <span
              class="icon is-small is-right search-return"
              (click)="showSearchBox('close')"
            >
              <i class="fa fa-times-circle"></i>
            </span>
          </div>
        </div>
      </div>
      }
      <div
        class="list-wrapper scroll-bar list-overflow"
        appInfiniteScroll
        infinite-scroll
        [infiniteScrollDistance]="modalScrollDistance"
        [infiniteScrollThrottle]="modalScrollThrottle"
        [scrollWindow]="false"
        (scrolled)="fetchStaffRoomList()"
      >
        <ul class="notification-list">
          @for (group of roomsList; track group) {
          <li
            class="cursor-pointer pos-relative chat-list"
            routerLinkActive="active"
          >
            <div
              class="columns is-gapless is-clearfix pos-relative display-flex"
              [routerLink]="['/staffroom/', group.group_id]"
            >
              <div class="column is-one-quarter">
                @if (group.group_icon) {
                <img [src]="profileUrl + group.group_icon" />
                } @if (!group.group_icon) {
                <empty-uname
                  [userName]="group.full_name"
                  [liProfile]="true"
                ></empty-uname>
                }
              </div>
              <div class="column is-clearfix">
                <p class="is-size-6 list-active">{{ group.full_name }}</p>
                @if (group.unread_post_count) {
                <span class="badge-count">{{ group.unread_post_count }}</span>
                }
              </div>
              <!-- <span class="badge-count" *ngIf="data.unread_post_count">{{data.unread_post_count}}</span> -->
            </div>
            <!-- <div class="chat-close">
                <i class="fa fa-trash-o" title="Delete Room" (click)="deleteRoom(group.group_id)"></i>
              </div> -->
          </li>
          }
          <pagination-loader
            [showFetchLoader]="showPaginateSpinner"
          ></pagination-loader>
        </ul>
      </div>
    </div>
  </div>
  }
  <div class="col px-2">
    <!-- <div class="modal welcome-window" [ngClass]="{'is-active': showWelcomeWindow}" *ngIf="is_tour_completed">
  <div class="modal-background"></div>
  <div class="modal-content">
    <div class="box" *ngIf="welcomeWindowName === 'welcome'">
      <div class="columns">
        <div class="column is-12 has-text-centered">
          <img [src]="'../../../../assets/images/welcome_chat.png'">
          <h2>Hi {{loggedUserDeatails?.first_name}}, Welcome to Canstring Class!</h2>
          <h4>Successfully signed up, now let us have a quick tour of the app.</h4>
        </div>
      </div>
      <div class="columns has-text-centered">
        <div class="column is-12">
          <a class="button is-small is-link" (click)="showOnboarding()">Explore Canstring class</a>
        </div>
      </div>
    </div>
  </div>
  <button class="modal-close is-large" (click)="welcomeWindow()" aria-label="close"></button>
</div> -->

    <!-- <div class="empty-state" *ngIf="totalRowCount === 0">
<div class="has-text-centered box">
  <img [src]="'../../../../assets/images/notification_empty.svg'">
  <p>No users record found. Please check the button below to create user!</p>

  <a class="button is-link is-small mar-top15 mar-0-5" id="createStudent" [routerLink]="['/userandgroup/user/newuser']">
    <span class="icon is-small">
      <i class="fa fa-plus is-small" style="font-size: 12px !important;"></i>
    </span>
    <span><i class=" fa-solid fa-circle-plus"></i>&nbsp;&nbsp; New User</span>
  </a>
</div>
</div> -->

    <router-outlet></router-outlet>
  </div>
</div>
